import { render, staticRenderFns } from "./GroupChat.vue?vue&type=template&id=e41c5648&"
import script from "./GroupChat.vue?vue&type=script&lang=js&"
export * from "./GroupChat.vue?vue&type=script&lang=js&"
import style0 from "./GroupChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports